export const ENDPOINT = process.env.REACT_APP_BACK_PRODUCTION ||
(process.env.NODE_ENV === 'development'
  ? 'http://localhost:3000/'
  : 'https://saaf-backend-production-dc37ebtbyq-ue.a.run.app/');
  
export const DEFAULT_HEADERS = {
  'Cache-Control': 'no-cache',
  'Content-Type': 'application/json',
  Accept: 'application/json',
};



// WEBPACK FOOTER //
// src/lib/api/configuration.js